<template>
  <div class="cases">
    <el-button type="primary" @click="openDialog()">新增字典</el-button>

    <el-table border :data="tableData" v-loading="loading" style="width: 100%">
      <el-table-column prop="Id" label="序号" width="180"></el-table-column>
      <el-table-column prop="Key" label="键" width="180"></el-table-column>
      <el-table-column prop="Content" label="值"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="handleEdit(scope.$index, scope.row)"
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="数据字典编辑" :visible.sync="dialogFormVisible">
      <el-form :model="formData">
        <el-form-item label="数据键" :label-width="formLabelWidth">
          <el-input v-model="formData.Key" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="数据值" :label-width="formLabelWidth">
          <el-input type="textarea" :rows="4" v-model="formData.Content" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCreateOrModify()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestJson } from "../../services/siteConfig";

export default {
  data() {
    return {
      loading: true,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      tableData: [],
      formData: {
        Id: 0,
        Key: "",
        Content: "",
        CreateTime: new Date()
      },
      options: {}
    };
  },
  mounted() {
    let token = "Browser " + sessionStorage.getItem("token");
    //window.console.log(token);
    this.options = {
      headers: {
        Authorization: token
      }
    };

    this.loadData();
  },
  methods: {
    adminHeaders() {
      return {
        Authorization: "Browser " + sessionStorage.getItem("token")
      };
    },
    cloneRow(row) {
      return {
        Id: Number(row && row.Id) || 0,
        Key: row && row.Key ? row.Key : "",
        Content: row && row.Content != null ? row.Content : ""
      };
    },
    loadData() {
      this.loading = true;
      requestJson(`/api/DataDictionary/GetDataDictionaryAll?key=`)
        .then(data => {
          this.tableData = Array.isArray(data) ? data : [];
        })
        .catch(e => {
          this.$message({
            message: "网络或程序异常！" + e.message,
            type: "error"
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
    openDialog() {
      this.formData = {
        Id: 0,
        Key: "",
        Content: "",
        CreateTime: new Date()
      };
      this.dialogFormVisible = true;
    },
    // 新增或修改
    handleCreateOrModify() {
      const isCreate = !this.formData.Id;
      const url = isCreate
        ? "/api/DataDictionary/CreateDataDictionary"
        : "/api/DataDictionary/ModifiedDataDictionary";

      this.loading = true;
      requestJson(url, {
        method: "POST",
        headers: this.adminHeaders(),
        body: JSON.stringify(this.cloneRow(this.formData))
      })
        .then(response => {
          if (response && response.State === false) {
            throw new Error(response.Messages || "保存失败");
          }
          this.$message({
            message: isCreate ? "创建成功！" : "修改成功！",
            type: "success"
          });
          this.dialogFormVisible = false;
          this.loadData();
        })
        .catch(e => {
          this.$message({
            message: "网络或程序异常！" + e.message,
            type: "error"
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
    handleEdit(index, row) {
      window.console.log(index, row);
      this.formData = this.cloneRow(row);
      this.dialogFormVisible = true;
    },
    handleDelete(index, row) {
      window.console.log(index, row);
      this.$confirm("此操作将永久删除此条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          return requestJson(`/api/DataDictionary/DeleteDataDictionary?id=${row.Id}`, {
            method: "POST",
            headers: this.adminHeaders()
          });
        })
        .then(response => {
          if (response && response.State === false) {
            throw new Error(response.Messages || "删除失败");
          }
          this.$message({
            message: "删除成功！",
            type: "success"
          });
          this.loadData();
        })
        .catch(e => {
          if (e === "cancel" || e === "close") {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          } else {
            this.$message({
              message: "网络或程序异常！" + (e.message || e),
              type: "error"
            });
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
    //时间格式化
    dateFormat: function(row) {
      //row 表示一行数据, CreateTime 表示要格式化的字段名称
      let t = new Date(row.CreateTime);
      return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate();
    }
  }
};
</script>

<style scoped>
.el-table {
  margin-top: 20px;
}
</style>